import { render, staticRenderFns } from "./wechatlist.vue?vue&type=template&id=4c9fc016&scoped=true"
import script from "./wechatlist.vue?vue&type=script&lang=js"
export * from "./wechatlist.vue?vue&type=script&lang=js"
import style0 from "./wechatlist.vue?vue&type=style&index=0&id=4c9fc016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9fc016",
  null
  
)

export default component.exports